App.filter('display', ['translateFilter', function(translateFilter){
    return function(input, options){
        var type = options.displayType || options.type;
        var thSep = function(nStr, dSep, thSep)
        {
        	nStr += '';
        	x = nStr.split(dSep);
        	x1 = x[0];
        	x2 = x.length > 1 ? dSep + x[1] : '';
        	var rgx = /(\d+)(\d{3})/;
        	while (rgx.test(x1)) {
        		x1 = x1.replace(rgx, '$1' + thSep + '$2');
        	}
        	return x1 + x2;
        }
        if(options && type){
            if(type=='date'){
                if(input===null || input===undefined) return ''
                var m = input || input===0 ? moment(input) : moment();
                if(options.addHours>0) { 
                    m = m.add(options.addHours, 'h')
                }
                if(options.utc) m = m.utc();
                if(options.def && !input) {
                    return options.def;
                }
                if(options.format=='fromNow') return m.fromNow()
                return m.format(options.format || window.userDateFormat || 'L');
            } else if(type=='duration'){
                if(input===null || input===undefined) return ''
                if(options.fromNow) { input = (new Date().getTime() - input)/1000 }
                else if(options.from) { input = (options.from - input)/1000 }
                if(input<1) return Math.floor(input*1000) + 'ms';
                input = Math.round(input)
                if(input<60) return input + 's';
                if(input<3600) return Math.floor(input/60) + 'm ' + (input%60 ? input%60 + 's' : '');
                if(input<86400) return Math.floor(input/3600) + 'h ' + (Math.round(input/60)%60 ? Math.floor(input/60)%60 + 'm' : '');
                return Math.floor(input/86400) + 'd ' + (Math.floor(input/3600)%24 ? Math.floor(input/3600)%24 + 'h ' : '') + (Math.floor(input/60)%60 ? Math.floor(input/60)%60 + 'm ' : '') + (input%60 ? input%60 + 's' : '');
            } else if(type=='number'){
                var output = (input || (input===0 && options.printZero) ? parseInt(input).toString() : (options.def || options.def===0 ? options.def.toFixed(0).toString() : ""));
                output = (''+output).replace(".", options.decimalSep || ".");
                if(output=='NaN' && options.ifNaN!==undefined) output = options.ifNaN;
                if(output)
                	output = thSep(output, options.decimalSep, options.decimalSep=='.' ? ',' : '.');
                return output;
            } else if(type=='decimal' || type=='currency'){
            	var decimals = options.decimals || 2;
            	if(options.decimals===0) decimals = 0;
            	if(input){
            		var s = ''+input;
            		var pi = s.indexOf('.');
            		//var vi = s.indexOf(',');
            		if(pi<0){
            			input = parseFloat((''+input).replace(',','.'));
            		}
                }
                var output = (input || (input===0 && options.printZero) ? input.toFixed(decimals).toString() :
                    (isNaN(options.def) ? options.def :
                    (options.def || options.def===0 ? options.def.toFixed(decimals).toString() : "")));
                if(options.removeZeros && options.decimals>0){
                    output = output.replace(/\.?0+$/,'');
                }
                if(output=='NaN' && options.ifNaN!==undefined) output = options.ifNaN;
                output = (''+output).replace(".", options.decimalSep || ".");
                if(output)
                	output = thSep(output, options.decimalSep, options.decimalSep=='.' ? ',' : '.');
                if(options.withSign && output[0]!='-') output = '+' + output;
                if(type=='currency') output = output + ' ' + (translateFilter('enums.currencySymbol.' + options.currency) || '¤');
                return output;
            } else if(type=='perc'){
                if(options.total>0)
                	if(options.decimals)
                		return (100 * parseFloat(input) / parseFloat(options.total)).toFixed(parseInt(options.decimals)).replace(".", options.decimalSep || ".") + '%';
                	else
                		return Math.round(100 * input / options.total) + '%';
                else
                    return '--';
            } else if(type=='boolean'){
                return input ? translateFilter('labels.YES') : translateFilter('labels.NO');
            } else if(type=='icon'){
                if(options.iconType=='flag'){
                    var a = input.split('_');
                    return 'famfamfam-flag-' + a[a.length-1].toLowerCase();
                }
                else
                    return '' + input;
            } else if(type=='language'){
                if(input)
                    return translateFilter('enums.language.' + input.replace(/!/g,''));
            } else if(type=='enum'){
                if(input)
                    return translateFilter('enums.' + options.enumType + '.' + input.replace(/!/g,''));
            } else if(type=='enumSet'){
                var out = '';
                if(input){
                    for(var i=0; i<input.length; i++){
                        if(input[i]){
                            if(out) out+=', ';
                            out += translateFilter('enums.' + options.enumType + '.' + input[i].replace(/!/g,''));
                        }
                    }
                }
                return out;
            } else if(type=='list'){
                var out = '';
                if(input){
                    for(var i=0; i<input.length; i++){
                        if(input[i]){
                            if(out) out+=', ';
                            if(options.dataSource){
                                out += options.displayField ? options.dataSource[input[i]][options.displayField] : options.dataSource[input[i]];
                            } else if(options.displayField)
                                out += input[i][options.displayField];
                            else
                                out += input[i];
                        }
                    }
                }
                return out;
            } else if(type=='json'){
                return JSON.stringify(input, null, 4);
            } else if(type=='xml'){
                let formatXml = (xml, tab) => { // tab = optional indent value, default is tab (\t)
                    var formatted = '', indent= '';
                    tab = tab || '\t';
                    xml.split(/>\s*</).forEach(function(node) {
                        if (node.match( /^\/\w/ )) indent = indent.substring(tab.length); // decrease indent by one 'tab'
                        formatted += indent + '<' + node + '>\r\n';
                        if (node.match( /^<?\w[^>]*[^\/]$/ )) indent += tab;              // increase indent
                    });
                    return formatted.substring(1, formatted.length-3);
                }
                return formatXml(input, options.indent || '\t');
            } else if(type=='unenum') {
                return (input || '').replace('_', ' ').toLowerCase().replace(/^\w/, c => c.toUpperCase());
            } else if(type=='highlight'){
                if(!options.highlight) return input;
                if(input)
                    return input.replace( new RegExp( "(" + options.highlight.replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1") + ")" , 'gi' ), "<span class=\"highlight\">$1</span>" );
            } else if(type=='searchhighlight'){
                if(input){
                    var result = input;
                    var tokens = options.highlight.split(' ');
                    if(options.maxlength && result.length>options.maxlength) {
                        var first = result.indexOf(tokens[0]);
                        if(first>options.maxlength/2){
                            result = '&hellip;' + result.substr(first-options.maxlength/2, first-options.maxlength/2+options.maxlength) + '&hellip;';
                        } else {
                            result = result.substr(0, options.maxlength) + '&hellip;';
                        }
                    }    
                    for(var i=0; i<tokens.length; i++){
                        result = result.replace( new RegExp( "(" + tokens[i].replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1") + ")" , 'gi' ), "<span class=\"highlight\">$1</span>" );
                    }
                    return result;
                }
            } else if(type=='fileicon'){
                if(input.indexOf('image')>=0){
                    return 'aqi-file-image';
                }
                if(input.indexOf('text')>=0){
                    return 'aqi-file-text';
                }
                if(input.indexOf('pdf')>=0){
                    return 'aqi-file-pdf';
                }
                if(input.indexOf('word')>=0){
                    return 'aqi-file-word';
                }
                if(input.indexOf('zip')>=0){
                    return 'aqi-file-zip';
                }
                if(input.indexOf('excel')>=0){
                    return 'aqi-file-excel';
                }
                if(options.extension=='xliff'){
                	return 'aqi-language';
                }
                return 'aqi-file';
            } else if(type=='timelineIcon'){
            	switch(input) {
	                case 'CREATE_PROJECT':
                        return 'aqi-action-new';
                    case 'BREAK_PROJECT':
	                    return 'aqi-action-split';
	                case 'CHANGE_STATUS':
                    	return 'aqi-action-changestatus';
                    case 'UPDATETMX':
	                case 'UPLOAD_FILE':
                    	return 'aqi-action-upload';
	                case 'CREATE_OFFER':
                    	return 'aqi-offer';
	                case 'MODIFY_OFFER':
                    	return 'aqi-action-edit';
                    case 'CANCEL_OFFER':
                        return 'aqi-action-cancel';
	                case 'ACCEPT_OFFER':
                    	return 'aqi-check';
	                case 'CREATE_USER':
                    	return 'aqi-action-adduser';
	                case 'DELETE_FILE':
                    	return 'aqi-action-delete';
	                case 'MODIFY_PROJECT':
	                case 'MODIFY_PROJECT_NOTES':
                    	return 'aqi-action-edit';
	                case 'ANALYSIS':
                    	return 'aqi-report';
	                case 'TRANSLATION':
                    	return 'aqi-translation';
	                case 'TRANSLATIONBACK':
                    	return 'aqi-action-go-back';
	                case 'DELIVERY':
                    	return 'aqi-status-delivered';
	                case 'SEND_LAYOUT':
                    	return 'aqi-action-go-forward';
	                case 'SEND_DTP':
                    	return 'aqi-action-go-forward';
                    case 'UPDATETM':
                        return 'aqi-tm';
                    case 'ASSIGN_PROJECT':
                        return 'aqi-action-assign';
                    case 'UNASSIGN_PROJECT':
                        return 'aqi-action-unassign';
                    case 'QAI_PROCESS_CREATE':
                        return 'aqi-ai-model';
                    case 'QAI_PROCESS_STARTIMPORT':
                    case 'QAI_PROCESS_ENDIMPORT':
                        return 'aqi-action-import';
                    case 'QAI_RUN_START':
                        return 'aqi-action-play';
                    case 'QAI_RUN_STOP':
                        return 'aqi-action-stop';
                    case 'QAI_RUN_END':
                        return 'aqi-result-success';
	            }
            }
        }
        return input;
    }
}]);
